/**
 * Formats a coordinate or distance for display: fixed millimetre precision
 * with no unit suffix. The panel's data convention is metres, and the unit
 * is left as implicit context for the viewer. Anything under half a
 * millimetre reads "0.000".
 *
 * Slightly negative values that round to zero are shown as "0.000" so the
 * readout never flickers to "-0.000" as the cursor moves.
 */
export function formatMeters(value: number): string {
  const fixed = value.toFixed(3);
  return fixed === "-0.000" ? "0.000" : fixed;
}
